export default "__VITE_ASSET__BocO_RYV__"